import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import Link from 'components/consumer/Link';
const SubcategoryCard = t0 => {
  const $ = _c(9);
  const {
    image,
    label,
    to
  } = t0;
  let t1;
  if ($[0] !== label || $[1] !== to) {
    t1 = <span className="text-xs font-bold text-gray no-underline lg:text-sm" to={to}>{label}</span>;
    $[0] = label;
    $[1] = to;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== image) {
    t2 = !!image && <JBImage src={image} className="h-9 object-contain w-12 lg:h-12 lg:w-16" trim="color" trimPad={20} alt="" width={68} />;
    $[3] = image;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== to) {
    t3 = <Link className="bg-gray-light7 justify-between items-center rounded-sm flex p-2 pl-4 no-underline border-gray-light7 border-solid border-2 transition-[border] duration-200 ease-[ease] max-sm:min-width-[220px] md:min-width-[220px] lg:p-4 lg:pl-5 focus:outline-0 hover:border-gray-light4" to={to}>{t1}{t2}</Link>;
    $[5] = t1;
    $[6] = t2;
    $[7] = to;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
SubcategoryCard.propTypes = {
  image: PropTypes.string,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired
};
export default SubcategoryCard;